 /*local */

// export const apiUrl      = "http://localhost:5080/fund/api/";
// export const baseUrl      = "http://localhost:5080/fund";
// export const mediaUrl      = "http://localhost:5080/fund/media/";
// export const carImageUrl      = "http://localhost:5080/fund/media/cars";
// export const sampleFileUrl      = "http://localhost:5080/fund/media/sample_file/";
// export const cmscontentURL       = "http://localhost:5080/fund/media/cmscontent";
// export const categoryURL       = "http://localhost:5080/fund/media/category";

// export const licenseURL       = "http://localhost:5080/fund/media/brokerlicense";
// export const insuranceURL       = "http://localhost:5080/fund/media/brokerinsurance";
// export const profileURL       = "http://localhost:5080/fund/media/brokerprofile";
// export const brokerURL       = "http://localhost:5080/fund/media/brokerimage";
// export const galleryUrl      = 'http://localhost:5080/fund/media/gallery';
// export const guideUrl      = 'http://localhost:5080/fund/media/guide';
// export const favouritesUrl      = 'http://localhost:5080/fund/media/favourites'; 
// export const chatURL       = "http://localhost:5080/fund/media/smilesy";
// export const assetUrl       = "http://localhost:3000/assets/";


/*Live */


export const apiUrl      = "https://a-fund.uxt.design/fund/api/";
export const baseUrl      = "https://a-fund.uxt.design/fund";
export const mediaUrl      = "https://a-fund.uxt.design/fund/media/";
export const carImageUrl      = "https://a-fund.uxt.design/fund/media/cars";
export const sampleFileUrl      = "https://a-fund.uxt.design/fund/media/sample_file/";
export const cmscontentURL       = "https://a-fund.uxt.design/fund/media/cmscontent";
export const categoryURL       = "https://a-fund.uxt.design/fund/media/category";

export const licenseURL       = "https://a-fund.uxt.design/fund/media/brokerlicense";
export const insuranceURL       = "https://a-fund.uxt.design/fund/media/brokerinsurance";
export const profileURL       = "https://a-fund.uxt.design/fund/media/brokerprofile";
export const brokerURL       = "https://a-fund.uxt.design/fund/media/brokerimage";
export const galleryUrl      = 'https://a-fund.uxt.design/fund/media/gallery';
export const favouritesUrl      = 'https://a-fund.uxt.design/fund/media/favourites'; 
export const chatURL       = "https://a-fund.uxt.design/fund/media/smilesy";
export const assetUrl       = "https://a-fund.uxt.design/fund/assets/";

/*Dev*/

// export const apiUrl      = "https://admin-lender.uxt.design/fund/api/";
// export const baseUrl      = "https://admin-lender.uxt.design/fund";
// export const mediaUrl      = "https://admin-lender.uxt.design/fund/media/";
// export const carImageUrl      = "https://admin-lender.uxt.design/fund/media/cars";
// export const sampleFileUrl      = "https://admin-lender.uxt.design/fund/media/sample_file/";
// export const cmscontentURL       = "https://admin-lender.uxt.design/fund/media/cmscontent";
// export const categoryURL       = "https://admin-lender.uxt.design/fund/media/category";

// export const licenseURL       = "https://admin-lender.uxt.design/fund/media/brokerlicense";
// export const insuranceURL       = "https://admin-lender.uxt.design/fund/media/brokerinsurance";
// export const profileURL       = "https://admin-lender.uxt.design/fund/media/brokerprofile";
// export const brokerURL       = "https://admin-lender.uxt.design/fund/media/brokerimage";
// export const galleryUrl      = 'https://admin-lender.uxt.design/fund/media/gallery';
// export const favouritesUrl      = 'https://admin-lender.uxt.design/fund/media/favourites'; 
// export const chatURL       = "https://admin-lender.uxt.design/fund/media/smilesy";
// export const assetUrl       = "https://admin-lender.uxt.design/fund/assets/";